<template>
  <div class="connect">
      <TopNavBar navtitle="联系我们"></TopNavBar>
      <div class="connectnr">
          <ul>
              <li>
                  <label><van-icon name="wap-home-o" />单位：</label>
                  <span>贵州省音乐家协会</span>
              </li>              
              <li>
                  <label><van-icon name="phone-o" />电话：</label>
                  <span><a href="tel:085185823989">0851-85823989</a></span>
              </li>
              <li>
                  <label><van-icon name="location-o" />地址：</label>
                  <span>贵州省贵阳市南明区宝山南路137号(文联艺术传习培训基地)</span>
              </li>
              <!-- <li>
                  <van-button type="primary" url="https://router.map.qq.com/short?l=c222353acd730a10a9d6613df4f0a4dc">一键导航</van-button>
              </li> -->
          </ul>
          <iframe src="https://router.map.qq.com/short?l=c222353acd730a10a9d6613df4f0a4dc" width="100%" height="400px" frameborder="0"/>
      </div>

      <footerTabber />
  </div>
</template>

<script>
import TopNavBar from '@/components/TopNavBar.vue';
import footerTabber from "@/components/footerTabber.vue";
export default {
    components: {
        TopNavBar,
        footerTabber
    }
}
</script>

<style>
.connectnr{background: #fff;width: 100%;box-sizing: border-box;padding: 15px;}
.connectnr ul{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}
.connectnr ul li{
    width: 100%;
    text-align: left;
    padding:15px 5px;
    border-bottom: solid 1px #efefef;
}
.connectnr ul li label{
    font-weight: bold;
    width: 30%;
}
.connectnr ul li span a{color: #333;}
.connectnr ul li:last-child{
    border: 0;
}
</style>